module.exports = __webpack_public_path__ + "static/media/Aircraft.816dd200.png";